import Api from "../../../../lib/api";
import SimpleVideo from "../../../../components/simple-video";

export default class FeedbackFilterService {
	static getReviews(city = '*', category = '*', options = {}) {
		return Api.get(craft.env.apiSiteUrl + '/feed/studentReviews', {
			currentCity: Api.currentCityId,
			city, category, ...options });
	}

	static initVideo($reviewsListContainer) {
		const $videos = $reviewsListContainer.querySelectorAll('.review-video');

		if (!$videos.length) return;

		const videoList = Array.from($videos).map(($video) => new SimpleVideo($video));
	}
}